import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

const ReportPollPage = () => {
  const { pollId } = useParams();
  const { user } = useAuth();
  const [status, setStatus] = useState("Reporting...");

  useEffect(() => {
    const submitReport = async () => {
      if (!user) {
        setStatus("Sign in to report this poll.");
        return;
      }
      try {
        await api.post(`/polls/${pollId}/report`);
        setStatus("Report submitted.");
      } catch (error) {
        toast.error("Unable to submit report.");
        setStatus("Report failed.");
      }
    };
    submitReport();
  }, [pollId, user]);
  return (
    <div className="space-y-4" data-testid="report-poll-page">
      <h2 className="text-2xl font-semibold" data-testid="report-poll-title">
        Report poll
      </h2>
      <p className="text-sm text-muted-foreground" data-testid="report-poll-subtitle">
        {status}
      </p>
      <div className="text-xs text-muted-foreground" data-testid="report-poll-id">
        Poll ID: {pollId}
      </div>
    </div>
  );
};

export default ReportPollPage;
